import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './login.component';
import { ServicesModule } from './../../shared/services/services.module';

import { LoginMainComponent } from './login-main/login-main.component';
import { LoginResetPasswordComponent } from './login-reset-password/login-reset-password.component';
import { LoginSendEmailComponent } from './responses/login-send-email/login-send-email.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppMaterialModule } from 'src/app/app-material.module';
import { SendEmailSuccessModalComponent } from './responses/modals/send-email-success-modal/send-email-success-modal.component';

const routes: Routes = [
  { path: '', component: LoginMainComponent },
  { path: 'forgot-password', component: LoginResetPasswordComponent },
  { path: 'send-email-pass-success', component: LoginSendEmailComponent },
];

@NgModule({
  declarations: [
    LoginComponent,
    LoginMainComponent,
    LoginResetPasswordComponent,
    LoginSendEmailComponent,
    SendEmailSuccessModalComponent
  ],
  providers: [],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ServicesModule,
    RouterModule.forChild(routes),
    AppMaterialModule,
  ],
  exports: [
    LoginMainComponent,
    LoginResetPasswordComponent
  ]
})
export class LoginModule {}
